export const ip = "https://api.syntech.lu";
//export const ip = "http://localhost:7087";
